import { CLIENT_STATE } from '../graphqls';

export default (_, data, { cache }) => {
  cache.writeQuery({
    query: CLIENT_STATE,
    data,
  });
};
